var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUpSlient3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.849,
    height: 179.371,
    viewBox: "0 0 283.849 179.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22762",
    "data-name": "Group 22762",
    transform: "translate(-107.699 -342.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12328",
    "data-name": "Path 12328",
    d: "M253.4,781.04c-39.394,0-71.324,4.058-71.324,9.066s31.93,9.064,71.324,9.064,71.321-4.056,71.321-9.064-31.932-9.066-71.321-9.066",
    transform: "translate(26.702 -277.795)",
    fill: "#d6daf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22813",
    "data-name": "Group 22813",
    transform: "translate(107.699 342.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22762-2",
    "data-name": "Group 22762",
    transform: "translate(32.768 135.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12298",
    "data-name": "Path 12298",
    d: "M710.953,1463.191a13.555,13.555,0,0,1-4-9.606v-7.022h-2.208v7.022A15.856,15.856,0,0,0,720.56,1469.4h35.782a15.854,15.854,0,0,0,15.813-15.812v-19.433h-2.208v19.433a13.649,13.649,0,0,1-13.6,13.6H720.56A13.558,13.558,0,0,1,710.953,1463.191Z",
    transform: "translate(-704.747 -1434.152)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22763",
    "data-name": "Group 22763",
    transform: "translate(50.206 0.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12299",
    "data-name": "Path 12299",
    d: "M798.68,708.136l2.013,138.771h229.618l2.012-138.771Z",
    transform: "translate(-798.68 -708.136)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22769",
    "data-name": "Group 22769",
    transform: "translate(50.206 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22764",
    "data-name": "Group 22764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12300",
    "data-name": "Path 12300",
    d: "M1032.068,724.18H798.934l-.255-17.551h233.643Z",
    transform: "translate(-798.679 -706.629)",
    fill: "#8ca3ca",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22767",
    "data-name": "Group 22767",
    transform: "translate(31.674 31.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12303",
    "data-name": "Path 12303",
    d: "M1021.663,878.729h117.928v3.613H1021.663v-3.613ZM969.3,962.213h170.295v3.615H969.3v-3.615Zm0-10.434h170.295v3.613H969.3v-3.613Zm0-10.437h170.295v3.615H969.3v-3.615Zm0-10.434h170.295v3.613H969.3v-3.613Zm52.367-10.436h117.928v3.613H1021.663v-3.613Zm0-10.436h117.928v3.613H1021.663v-3.613Zm0-10.435h117.928v3.614H1021.663V899.6Zm0-10.436h117.928v3.613H1021.663Z",
    transform: "translate(-969.296 -878.729)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22768",
    "data-name": "Group 22768",
    transform: "translate(31.68 31.918)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3604",
    "data-name": "Rectangle 3604",
    width: 44.881,
    height: 44.881,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22770",
    "data-name": "Group 22770",
    transform: "translate(238.861 23.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12304",
    "data-name": "Path 12304",
    d: "M1829.847,830.725a1.459,1.459,0,1,0,1.46,1.458,1.458,1.458,0,0,0-1.46-1.458Zm-13.492,0a1.459,1.459,0,1,0,1.458,1.458,1.459,1.459,0,0,0-1.458-1.458Zm6.746,0a1.459,1.459,0,1,0,1.458,1.458A1.458,1.458,0,0,0,1823.1,830.725Z",
    transform: "translate(-1814.895 -830.725)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22771",
    "data-name": "Group 22771",
    transform: "translate(0 36.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12305",
    "data-name": "Path 12305",
    d: "M588.3,902.23H538.42a8.756,8.756,0,0,0-8.736,8.736v15.077h0a1.452,1.452,0,0,0-1.448,1.448v12.27a1.452,1.452,0,0,0,1.448,1.449h0v77.868a8.756,8.756,0,0,0,8.736,8.735H588.3a8.756,8.756,0,0,0,8.736-8.735V953.049c.041,0,.081,0,.123,0h0a1.453,1.453,0,0,0,1.449-1.449V939.336a1.453,1.453,0,0,0-1.449-1.449h0c-.042,0-.082,0-.123,0v-4.174c.041,0,.081.006.123.006h0a1.452,1.452,0,0,0,1.449-1.448V920a1.453,1.453,0,0,0-1.449-1.449h0c-.042,0-.082,0-.123.005v-7.6A8.756,8.756,0,0,0,588.3,902.23Z",
    transform: "translate(-528.237 -902.23)",
    fill: "#8ca3ca",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22773",
    "data-name": "Group 22773",
    transform: "translate(6.469 41.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12306",
    "data-name": "Path 12306",
    d: "M616.741,927.586H566.859a3.963,3.963,0,0,0-3.778,4.1v108.332a3.964,3.964,0,0,0,3.778,4.106h49.883a3.964,3.964,0,0,0,3.778-4.106V931.691A3.963,3.963,0,0,0,616.741,927.586Z",
    transform: "translate(-563.081 -927.586)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22777",
    "data-name": "Group 22777",
    transform: "translate(9.396 47.858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3606",
    "data-name": "Rectangle 3606",
    width: 51.581,
    height: 102.865,
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22781",
    "data-name": "Group 22781",
    transform: "translate(13.382 58.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3608",
    "data-name": "Rectangle 3608",
    width: 23.656,
    height: 4.714,
    transform: "translate(0 0)",
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22782",
    "data-name": "Group 22782",
    transform: "translate(13.368 98.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3609",
    "data-name": "Rectangle 3609",
    width: 23.656,
    height: 5.374,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22783",
    "data-name": "Group 22783",
    transform: "translate(42.235 57.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12312",
    "data-name": "Path 12312",
    d: "M770.086,1024.85a7.171,7.171,0,1,1-7.222-7.12A7.17,7.17,0,0,1,770.086,1024.85Z",
    transform: "translate(-755.744 -1017.729)",
    fill: "#c4d1eb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22784",
    "data-name": "Group 22784",
    transform: "translate(47.34 59.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12313",
    "data-name": "Path 12313",
    d: "M787.325,1029.183a2.042,2.042,0,1,1-2.056-2.028A2.041,2.041,0,0,1,787.325,1029.183Z",
    transform: "translate(-783.241 -1027.156)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22785",
    "data-name": "Group 22785",
    transform: "translate(45.639 64.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12314",
    "data-name": "Path 12314",
    d: "M777.842,1052.922h0a3.79,3.79,0,0,0-3.763,3.817h0a.994.994,0,0,0,1,.986l5.59-.04a.993.993,0,0,0,.988-1h0A3.79,3.79,0,0,0,777.842,1052.922Z",
    transform: "translate(-774.079 -1052.921)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22786",
    "data-name": "Group 22786",
    transform: "translate(41.913 75.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12315",
    "data-name": "Path 12315",
    d: "M754.01,1113.1H769v1.423H754.01V1113.1Zm0,9.779H769v1.423H754.01v-1.423Zm0-3.26H769v1.423H754.01v-1.423Zm0-3.259H769v1.423H754.01Z",
    transform: "translate(-754.01 -1113.101)",
    fill: "#c4d1eb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22787",
    "data-name": "Group 22787",
    transform: "translate(41.914 92.606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3610",
    "data-name": "Rectangle 3610",
    width: 14.986,
    height: 11.563,
    transform: "translate(0)",
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22788",
    "data-name": "Group 22788",
    transform: "translate(13.368 107.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3611",
    "data-name": "Rectangle 3611",
    width: 13.993,
    height: 11.563,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22789",
    "data-name": "Group 22789",
    transform: "translate(28.002 107.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3612",
    "data-name": "Rectangle 3612",
    width: 13.992,
    height: 11.563,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22790",
    "data-name": "Group 22790",
    transform: "translate(42.635 107.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3613",
    "data-name": "Rectangle 3613",
    width: 13.994,
    height: 11.563,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22791",
    "data-name": "Group 22791",
    transform: "translate(13.368 131.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3614",
    "data-name": "Rectangle 3614",
    width: 13.993,
    height: 5.781,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22792",
    "data-name": "Group 22792",
    transform: "translate(28.002 131.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3615",
    "data-name": "Rectangle 3615",
    width: 13.992,
    height: 5.781,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22793",
    "data-name": "Group 22793",
    transform: "translate(42.635 131.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3616",
    "data-name": "Rectangle 3616",
    width: 13.994,
    height: 5.781,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22794",
    "data-name": "Group 22794",
    transform: "translate(13.368 140.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3617",
    "data-name": "Rectangle 3617",
    width: 13.993,
    height: 5.781,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22795",
    "data-name": "Group 22795",
    transform: "translate(28.002 140.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3618",
    "data-name": "Rectangle 3618",
    width: 13.992,
    height: 5.781,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22796",
    "data-name": "Group 22796",
    transform: "translate(42.635 140.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3619",
    "data-name": "Rectangle 3619",
    width: 13.994,
    height: 5.781,
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22797",
    "data-name": "Group 22797",
    transform: "translate(20.543 126.089)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3620",
    "data-name": "Rectangle 3620",
    width: 29.285,
    height: 0.926,
    transform: "translate(0 0)",
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22798",
    "data-name": "Group 22798",
    transform: "translate(13.957 127.601)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3621",
    "data-name": "Rectangle 3621",
    width: 42.46,
    height: 0.926,
    transform: "translate(0)",
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22799",
    "data-name": "Group 22799",
    transform: "translate(13.957 129.114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3622",
    "data-name": "Rectangle 3622",
    width: 42.46,
    height: 0.925,
    transform: "translate(0 0)",
    fill: "#c4d1eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22812",
    "data-name": "Group 22812",
    transform: "translate(120.965 32.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22800",
    "data-name": "Group 22800",
    transform: "translate(0 10.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12316",
    "data-name": "Path 12316",
    d: "M1220.685,956.766c-1.606-1.5-6.085-3.157-8.754-3.975a63.474,63.474,0,0,0-9.141-.466q-8.385-.081-18.021.175.9-4.059.176-12.052a6.353,6.353,0,0,0-3.726-.378c-2.11,11.179-1.6,16.361.087,18.923a80.531,80.531,0,0,0,12.839,2.328q1.5,9.618,2.272,18.545a82.365,82.365,0,0,0-1.513,12.81q14.691,2.171,23.581.117a55.166,55.166,0,0,0-1.359-6.245c.648-8.045,1.678-13.27,2.234-16.987q5.3,10.713,9.374,11.121,3.453-.7,7.454-16.826a2.962,2.962,0,0,0-3.086-1.339q-4.4,6.482-5.065,9.4C1225.929,964.958,1223.819,960.79,1220.685,956.766Z",
    transform: "translate(-1179.83 -939.961)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22801",
    "data-name": "Group 22801",
    transform: "translate(20.924 8.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12317",
    "data-name": "Path 12317",
    d: "M1295.829,941.351c.6-.282,3.872-.223,7.142.449a6.3,6.3,0,0,1-.825-2.07c-5.834-.875-5.263-2.319-5.048-2.976,1.177-3.131,1.889-5.108,1.042-6.048a2.95,2.95,0,0,0-1.708,2.058c-.368-.222-.837-.517-.9-.936-.139-1.251-.1-3.859-1.529-4.077q-.425,1.718-.754,3.65c-.82.656-.9,3.293-.406,6.374q-.712,2.549,3,3.046Z",
    transform: "translate(-1292.538 -927.751)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22802",
    "data-name": "Group 22802",
    transform: "translate(20.271 3.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12318",
    "data-name": "Path 12318",
    d: "M1294.233,912.9c-.215.657-.786,2.1,5.048,2.976a7.913,7.913,0,0,0,5.289-3.516c3.409-5.7.241-8.423-1.484-9.458-.381-5.9-9.234-1.327-13.292-4.443-1.853,2.218.032,5.293,1.346,5.437,1.433.218,1.39,2.826,1.529,4.077.061.419.529.713.9.936a2.95,2.95,0,0,1,1.708-2.057C1296.122,907.8,1295.41,909.772,1294.233,912.9Z",
    transform: "translate(-1289.02 -898.463)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22803",
    "data-name": "Group 22803",
    transform: "translate(23.227 22.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12319",
    "data-name": "Path 12319",
    d: "M1313.074,1000.756a6.763,6.763,0,0,1,.944,1.11l-.2-.062a63.01,63.01,0,0,0-8.874-.469,5.755,5.755,0,0,1,.988-1.028C1306.532,1000.026,1309.8,1000.085,1313.074,1000.756Z",
    transform: "translate(-1304.945 -1000.148)",
    fill: "#466fb5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22804",
    "data-name": "Group 22804",
    transform: "translate(1.652 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12320",
    "data-name": "Path 12320",
    d: "M1188.73,892.247a18.986,18.986,0,0,1,.551-5.288c.971-.863.706-1.577,1.781-1.837,1.2-2.517,1.07-2.914,1.088-3.841,1.388.189,1.2,2.118-.113,5.7q-.358,3.212,1.6,1.886c.531-1.461,1.369-1.815,1.959-1.714-.064.191-.484,1.043-1.073,2.485a7.039,7.039,0,0,1-2.165,2.4,1.266,1.266,0,0,0-.47.5A6.438,6.438,0,0,0,1188.73,892.247Z",
    transform: "translate(-1188.73 -881.281)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22805",
    "data-name": "Group 22805",
    transform: "translate(53.31 26.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12321",
    "data-name": "Path 12321",
    d: "M1467.362,1029.181c.092-1.348-.424-2.386-.366-5.312q1.285.087,1.122,2.547a3.8,3.8,0,0,0,1.339-3.072q.024-.888.007-1.4,2.1-.633,2.38,4.243a14.689,14.689,0,0,1-1.222,2.343,11.6,11.6,0,0,0-.756,1.8A2.883,2.883,0,0,0,1467.362,1029.181Z",
    transform: "translate(-1466.991 -1021.874)",
    fill: "#fab688",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22806",
    "data-name": "Group 22806",
    transform: "translate(13.088 63.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12322",
    "data-name": "Path 12322",
    d: "M1275.118,1224.526c1.172,7.938,1.719,20.448,1.642,32.516,1.13,5.728,1.072,14.884-.175,33.456a16.016,16.016,0,0,1-5.735.262c-2.871-17.328-3.968-26.359-3.29-33.079-.876-4.824-2.08-13.678-3.61-20.577-1.531,6.9-2.734,15.753-3.611,20.577.677,6.72-.419,15.751-3.29,33.079a16.018,16.018,0,0,1-5.736-.262c-1.247-18.571-1.3-27.728-.174-33.456-.078-12.177.481-24.8,1.674-32.728Q1266.528,1226.288,1275.118,1224.526Z",
    transform: "translate(-1250.333 -1224.315)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22807",
    "data-name": "Group 22807",
    transform: "translate(11.918 132.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12323",
    "data-name": "Path 12323",
    d: "M1250.953,1597.215c.547.426.678,2.408.235,3.914a5.977,5.977,0,0,1-5.269-.239c-.866-.336-1.91-.906-1.89-1.53.039-1.181.065-1.207,2.492-2.463q-.054.359-.12.663h0c.106.279.322.487.727.227.443-.291.293-1.23,1.555-1.253,1.043-.017,1.054.982,1.564,1.314C1250.808,1598.236,1250.929,1597.653,1250.953,1597.215Z",
    transform: "translate(-1244.029 -1596.532)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22808",
    "data-name": "Group 22808",
    transform: "translate(34.013 132.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12324",
    "data-name": "Path 12324",
    d: "M1363.546,1597.192c-.547.425-.678,2.406-.235,3.911a5.978,5.978,0,0,0,5.269-.238c.265-.127,1.31-.464,1.393-.75.294-1.012.04-2.362-2-3.245.036.241.075.463.119.666h0c-.107.277-.321.488-.726.227-.442-.291-.293-1.233-1.555-1.254-1.044-.015-1.054.982-1.564,1.316C1363.693,1598.212,1363.571,1597.631,1363.546,1597.192Z",
    transform: "translate(-1363.045 -1596.508)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22809",
    "data-name": "Group 22809",
    transform: "translate(14.291 129.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12325",
    "data-name": "Path 12325",
    d: "M1261.4,1581.673a18.379,18.379,0,0,0-.154,3.785c-.1.2-.275.293-.593.072-.51-.333-.521-1.331-1.563-1.314-1.262.023-1.112.962-1.555,1.253-.4.261-.62.052-.727-.227a21.84,21.84,0,0,0,.352-3.834A16.714,16.714,0,0,0,1261.4,1581.673Z",
    transform: "translate(-1256.81 -1581.408)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22810",
    "data-name": "Group 22810",
    transform: "translate(34.473 129.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12326",
    "data-name": "Path 12326",
    d: "M1365.525,1581.649a18.389,18.389,0,0,1,.154,3.785c.1.2.275.294.592.073.51-.334.521-1.331,1.564-1.316,1.262.021,1.113.963,1.555,1.254.4.261.62.051.726-.227a21.922,21.922,0,0,1-.352-3.835A16.809,16.809,0,0,1,1365.525,1581.649Z",
    transform: "translate(-1365.525 -1581.383)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22811",
    "data-name": "Group 22811",
    transform: "translate(2.059 22.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12327",
    "data-name": "Path 12327",
    d: "M1203.174,1011.415a187.621,187.621,0,0,1,5.012,18.453q4.781,3.322,6.706,4.891-6.766-3.814-8.32-4.739-1.592,3.943-2.64,12.75a82.412,82.412,0,0,1,1.514-12.81q-.774-8.928-2.272-18.545Zm35.2,15.53a14.434,14.434,0,0,0-1.308-4.931,10.909,10.909,0,0,1,.646-1.867,18.32,18.32,0,0,1,.662,6.8Zm-44.574-24.351a9.251,9.251,0,0,0-2.88,1.554q1.735-1.548,3.085-2.673c-.059.4-.127.77-.2,1.119Zm35.053,14a25.472,25.472,0,0,1-.463,3.059c-.556,3.717-1.586,8.942-2.234,16.987a55.092,55.092,0,0,1,1.36,6.245c-.124.029-.249.057-.376.084a35.114,35.114,0,0,0-1.816-5.476,15.6,15.6,0,0,1-3.252,1.186q1.178-1.042,2.344-2.017A200.188,200.188,0,0,1,1228.851,1016.595Z",
    transform: "translate(-1190.919 -1001.474)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpSlient3);
export default __webpack_public_path__ + "static/media/sign-up-slient3.d6ac497c9259c2784662ee7f119d8ca4.svg";
export { ForwardRef as ReactComponent };